import styled from 'styled-components'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { NavLink } from 'react-router-dom'
import { useState } from 'react'
import { useSelector } from 'react-redux'

const Container=styled.div`

 `;



 export default function Navigation(){
 	const [value, setValue] = useState(4);
 	const estadoReventas=useSelector(state=>state.reventa.reventasEstado);
 	const usuario=useSelector(state=>state.login.user)


 	const handleChange=(e,newValue)=>{ setValue(newValue)	};
 
 	return(
 		<Container>
 			<Box >
	     		<Tabs value={value} disabled={true} onChange={handleChange}  style={{ textDecoration: "none" }} textColor="primary" indicatorColor="primary" allowScrollButtonsMobile scrollButtons variant="scrollable" >
        			<Tab disabled={estadoReventas!==0?true:false}  label="juegos" to="/Home/juegos" component={NavLink} />
        			<Tab disabled={estadoReventas!==0?true:false}  label="cuentas" to="/Home/cuentas" component={NavLink} />
        			<Tab  label="reventas" to="/Home/reventas/reventasPublicadas" component={NavLink} />	
        			{usuario.tipo===1?<Tab disabled={estadoReventas!==0?true:false}  label="usuarios"  to="/Home/usuarios" component={NavLink} />:null}
        			<Tab disabled={estadoReventas!==0?true:false}  label="solicitudes"  to="/Home/solicitudes" component={NavLink} />       		 	
      			</Tabs>
      		</Box>
 			
 		</Container>
 		)
 }